import fetchInterceptor,{FetchOptions} from "../../../utils/fetchInterceptor ";
import { blogEndpoints } from "../apiEndpoints";
import { header } from "../../../context/constant";

const GetBlogAPI = async (id?: string) => {
  const url = id ? blogEndpoints.single(id) : blogEndpoints.all();
  const options: FetchOptions = {
    method: "GET",
    headers: header,
  };
  return fetchInterceptor(url, options);
};

export default GetBlogAPI;